module.exports = {
  GAB: 'gab',
  FOURCHAN: '4chan',
  EIGHTKUN: '8kun',
  PARLER: 'parler',
  WIN: 'win',
  POAL: 'poal',
  TELEGRAM: 'telegram',
  GETTR: 'gettr',
  BITCHUTE_VIDEO: 'bitchute_video',
  BITCHUTE_COMMENT: 'bitchute_comment',
  TIKTOK_VIDEO: 'tiktok_video',
  TIKTOK_COMMENT: 'tiktok_comment',
  WIMKIN: 'wimkin',
  MEWE: 'mewe',
  RUMBLE_VIDEO: 'rumble_video',
  RUMBLE_COMMENT: 'rumble_comment',
  LBRY_VIDEO: 'lbry_video',
  LBRY_COMMENT: 'lbry_comment',
  MINDS: 'minds',
  VK: 'vk',
  TRUTH_SOCIAL: 'truth_social',
  RUTUBE_VIDEO: 'rutube_video',
  RUTUBE_COMMENT: 'rutube_comment',
  OK: 'ok',
  BLUESKY: 'bluesky',
  FEDIVERSE: 'fediverse',
  WHATSAPP: 'whatsapp',
  NO_LIMIT_SITES: [
    'whatsapp'
  ]
}
